import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=371bdd21&scoped=true&"
import script from "./file-upload.vue?vue&type=script&lang=ts&"
export * from "./file-upload.vue?vue&type=script&lang=ts&"
import style0 from "./file-upload.vue?vue&type=style&index=0&id=371bdd21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371bdd21",
  null
  
)

export default component.exports